<template>
  <div class="comMain">
    <div class="title">
      <div class="_p">{{title}}</div>
    </div>
    <div class="grey"></div>
    <div class="page_view">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
    name:"comMain",
    data() {
        return {
            
        }
    },
    props:{
        'title':{
            type:String,
            default:''
        }
    }
}
</script>
<style lang='less' scoped>
.comMain {
  .title {
    position: relative;
    height: 64px;
    display: flex;
    align-items: center;

    ._p {
      font-size: 16px;
      position: relative;
      color: #333333;

      &::after {
        content: "";
        position: absolute;
        width: 4px;
        left: -20px;
        top: 5px;
        bottom: 5px;
        background: #fabe00;
      }
    }
    ._back{
        position: absolute;
        right: 0;
        height: 30px;
        line-height: 30px;
        width: 120px;
        font-size: 14px;
        text-align: center;
        border-radius: 4px;
        background: #fabe00;
        cursor: pointer;
    }
  }

  .grey{
    height: 20px;
    background: #F7F6F5;
    margin-left: -20px;
    margin-right: -20px;
  }
  .page_view{
    padding-top: 20px;
    /deep/.el-table--border th.gutter:last-of-type {
        display: table-cell !important;
    }
  }


  .yd_warning{
     color: #FABE00; 
  }
  .yd_danger{
     color: #F56C6C;
  }
  .yd_success{
     color: #67C23A;
  }
}

.ydcolor{
  /deep/ .el-button--primary{
    background-color:#FABE00;
    border-color: #FABE00;
  }
}
</style>